import { slugify } from '@/helpers';
import { OrderApiException, OrderErrorCode, OrderMeal, OrderMealRequest } from '@/models';
import { Routes } from '@/router';
import { NutritionCalculatorAddToBagEvent, NutritionLinkClickEvent } from '@/services/analytics/events';
import { AnalyticsMealType, NutritionLinkClickType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RecentMeal } from '../CmgNutritionCalculatorRecents/cmg-nutrition-calculator-recents';
import { getAddToBagInteraction } from '@/services/analytics/platforms/adobe-analytics/helpers';
import { AddToBagWebInteraction } from '@/services/analytics/platforms/adobe-analytics/constants';
import { AdobeNutritionCalculatorCartAddEvent } from '@/services/analytics/platforms/adobe-analytics/adobe-events';

@Component({
  name: 'CmgNutritionCalculatorRecentsCard',
})
export default class CmgNutritionCalculatorRecentsCard extends Vue {
  @Prop({ required: true })
  meal!: RecentMeal;

  @Prop({ required: true, type: Number })
  linkPosition!: number;

  addingToBag = false;

  get nutrition() {
    return this.$services.mealBuilderV2.getRecentMealNutrition(this.meal.item);
  }

  get calories() {
    return !this.nutrition?.tcal && this.nutrition?.tcal !== 0 ? '???' : Math.round(this.nutrition?.tcal);
  }

  get fat() {
    return !this.nutrition?.tfat && this.nutrition?.tfat !== 0 ? '???' : Math.round(this.nutrition?.tfat);
  }

  get protein() {
    return !this.nutrition?.prot && this.nutrition?.prot !== 0 ? '???' : Math.round(this.nutrition?.prot);
  }
  
  get carbs() {
    return !this.nutrition?.carb && this.nutrition?.carb !== 0 ? '???' : Math.round(this.nutrition?.carb);
  }

  onViewFull() {
    const newMealBuilderState = this.$services.mealBuilderV2.loadRecentMealToState(this.meal.item);
    if (newMealBuilderState.topLevelMenuItemTitle) {
      this.$router.push({ name: Routes.NutritionCalculcatorMealBuilder, params: { topLevelName: slugify(newMealBuilderState.topLevelMenuItemTitle) } });
    }

    this.$services.analytics.send(new NutritionLinkClickEvent(NutritionLinkClickType.NutritionBreakdown, this.meal.item, this.nutrition));
  }

  async onClickAddToBag() {
    this.addingToBag = true;
    const addMealToBagResult = this.$services.mealBuilderV2.addRecentMealToBag(this.meal.item);

    addMealToBagResult.then(res => {
      this.$services.bag.setBagVisibility(true);
      this.$nextTick(() => {
        Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
        this.$services.ui.setLastSelectedElement('bag');
      });

      const order = this.$services.order.getCurrentOrder();
      const orderMeal = (res as OrderMealRequest).meal as OrderMeal;

      if (order && orderMeal) {
        this.sendAddToBagEvent(orderMeal);
      }
    }).catch(err => {
      if (err instanceof OrderApiException && err.errors[0].errorCode == OrderErrorCode.MaxEntreeLimitExceeded) {
        this.$services.ui.setModalVisibility('maxEntreeLimitModal', true, { maxEntreeLimitNumber: err.errors[0].errorData });
      } else {
        throw err;
      }
    });

    this.addingToBag = false;
  }

  sendAddToBagEvent(orderMeal: OrderMeal): void {
    this.$services.analytics.addLinkClickedEventToStore(getAddToBagInteraction(AddToBagWebInteraction, this.meal.item.menuItemName, this.linkPosition));
    this.$services.analytics.setAddToBagEventToStore(new AdobeNutritionCalculatorCartAddEvent(new NutritionCalculatorAddToBagEvent(orderMeal, AnalyticsMealType.Recent, this.nutrition), this.$appStore, this.$services));
  }
}
